import React from "react";

const main_url = "https://ustron.pl/"
const museum_url = "https://muzeum.ustron.pl";

export { main_url, museum_url };